import { Box, Icon, Text } from "@chakra-ui/react";
import type { IconType } from "react-icons";

export const LinkCard = ({
  icon,
  label,
  sublabel,
  onOpen,
}: {
  icon?: IconType;
  label: string;
  sublabel?: string | null;
  onOpen: () => void;
}) => (
  <Box
    as="button"
    type="button"
    onClick={onOpen}
    display="flex"
    alignItems="center"
    gap="2"
    px="3"
    py="2"
    borderWidth="1px"
    borderColor="smBorder"
    borderRadius="lg"
    bg="smBackground"
    textAlign="left"
    _hover={{ borderColor: "smPrimary", bg: "smPrimarySofter" }}
  >
    {icon && <Icon as={icon} boxSize="4" color="smPrimary" flexShrink={0} />}
    <Box minW="0">
      <Text fontSize="sm" fontWeight="semibold" color="smText" noOfLines={1}>
        {label}
      </Text>
      {sublabel && (
        <Text fontSize="xs" color="smTextDisabled" noOfLines={1}>
          {sublabel}
        </Text>
      )}
    </Box>
  </Box>
);
